var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C10.1435 4 8.36301 4.7375 7.05025 6.05025C5.7375 7.36301 5 9.14349 5 11V11.1707C5.31278 11.0602 5.64936 11 6 11C7.65685 11 9 12.3431 9 14V16C9 17.6569 7.65685 19 6 19C4.34315 19 3 17.6569 3 16V11C3 8.61305 3.94821 6.32387 5.63604 4.63604C7.32387 2.94821 9.61305 2 12 2C14.387 2 16.6761 2.94821 18.364 4.63604C20.0518 6.32387 21 8.61305 21 11V14L21 14.0028V16C21 17.3633 20.0906 18.5142 18.8454 18.8792C18.5072 19.8121 17.6547 20.5333 16.6899 21.0157C15.3939 21.6637 13.7065 22 12 22C11.4477 22 11 21.5523 11 21C11 20.4477 11.4477 20 12 20C13.4761 20 14.8409 19.7042 15.7954 19.2269C16.1781 19.0355 16.4442 18.8441 16.627 18.6681C15.6607 18.1698 15 17.1621 15 16V14C15 12.3431 16.3431 11 18 11C18.3506 11 18.6872 11.0602 19 11.1707V11C19 9.14349 18.2625 7.36301 16.9498 6.05025C15.637 4.7375 13.8565 4 12 4ZM5 16V14C5 13.4477 5.44771 13 6 13C6.55228 13 7 13.4477 7 14V16C7 16.5523 6.55228 17 6 17C5.44771 17 5 16.5523 5 16ZM17 14C17 13.4477 17.4477 13 18 13C18.5523 13 19 13.4477 19 14V16C19 16.5523 18.5523 17 18 17C17.4477 17 17 16.5523 17 16V14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.98d93846040fbedd9e897349bef0fdd6.svg";
export { ForwardRef as ReactComponent };